import { Action, handleActions } from 'redux-actions'
import { UserDto } from '../../../services/api.types'
import {
  getCompanyUsersFail,
  getCompanyUsersSuccess,
  setCompanyUsersLoading,
  setUserDivisionSuccess,
  bulkDeleteUsersStart,
  bulkDeleteUsersSuccess,
  bulkDeleteUsersFail,
  bulkAddAdminRoleStart,
  bulkAddAdminRoleSuccess,
  bulkAddAdminRoleFail,
  bulkRemoveAdminRoleStart,
  bulkRemoveAdminRoleSuccess,
  bulkRemoveAdminRoleFail,
} from './UserManagementActions'

class State {
  companyUsers: UserDto[] = []
  usersLoading = false
  usersLoaded = false
  lastDivisionSet: number | null = null
  bulkDeleteInProgress = false
  adminRoleInProgress = false
}

export const userManagement = handleActions<State, any>(
  {
    [String(setCompanyUsersLoading)]: (state: State): State => ({
      ...state,
      companyUsers: [],
      usersLoading: true,
      usersLoaded: false,
      bulkDeleteInProgress: false,
      adminRoleInProgress: false,
    }),
    [String(getCompanyUsersSuccess)]: (state: State, action: Action<UserDto[]>): State => ({
      ...state,
      companyUsers: action.payload,
      usersLoading: false,
      usersLoaded: true,
    }),
    [String(getCompanyUsersFail)]: (state: State): State => ({
      ...state,
      usersLoading: false,
      usersLoaded: true,
    }),
    [String(setUserDivisionSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      lastDivisionSet: new Date().getTime(),
    }),
    [String(bulkDeleteUsersStart)]: (state: State): State => ({
      ...state,
      bulkDeleteInProgress: true,
    }),
    [String(bulkDeleteUsersSuccess)]: (state: State): State => ({
      ...state,
      bulkDeleteInProgress: false,
    }),
    [String(bulkDeleteUsersFail)]: (state: State): State => ({
      ...state,
      bulkDeleteInProgress: false,
    }),
    [String(bulkAddAdminRoleStart)]: (state: State): State => ({
      ...state,
      adminRoleInProgress: true,
    }),
    [String(bulkAddAdminRoleSuccess)]: (state: State): State => ({
      ...state,
      adminRoleInProgress: false,
    }),
    [String(bulkAddAdminRoleFail)]: (state: State): State => ({
      ...state,
      adminRoleInProgress: false,
    }),
    [String(bulkRemoveAdminRoleStart)]: (state: State): State => ({
      ...state,
      adminRoleInProgress: true,
    }),
    [String(bulkRemoveAdminRoleSuccess)]: (state: State): State => ({
      ...state,
      adminRoleInProgress: false,
    }),
    [String(bulkRemoveAdminRoleFail)]: (state: State): State => ({
      ...state,
      adminRoleInProgress: false,
    }),
  },
  new State(),
)

export { State as UserManagementState }
